import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { Button } from '@/components/UI/Button/Button';
import { ellipsisMultiline } from '@/styles/helpers';

export const CardItem = styled.div`
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  gap: 10px;
  min-width: 0;
  padding: 10px 15px;
  border-radius: 14px;
  border: 1px solid ${({ theme }) => theme.palette.secondary.border};
  background-color: ${({ theme }) => theme.palette.secondary.background};
  box-sizing: border-box;
`;

export const CardLogo = styled.img`
  width: 45px;
  height: 30px;
  object-fit: contain;
  flex-shrink: 0;
`;

export const CardMain = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
  flex: 1;
`;

export const Info = styled.div`
  min-width: 0;
  flex: 1;
`;

export const Name = styled(Typography.Body)`
  ${ellipsisMultiline(1)};
  margin-bottom: 5px;
`;

export const CardDetails = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 5px;
`;

export const BankName = styled(Typography.Body)`
  color: ${({ theme }) => theme.palette.secondary.labels};
`;

export const AdditionalInfo = styled(Typography.Body)<{ $isGreen: boolean }>`
  color: ${({ theme, $isGreen }) =>
    $isGreen ? theme.palette.system.green : theme.palette.system.red};
`;

export const Actions = styled.div`
  position: relative;
  flex-shrink: 0;
  display: flex;
`;

export const MoreButton = styled(Button).attrs({
  size: 'm',
  hasPadding: false,
  appearance: 'transparent',
})`
  && {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
